import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, Instagram } from 'lucide-react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-[#F2EEE7]" data-testid="contact-page">
      {/* Navigation */}
      <nav className="border-b border-[#D4CFC7] bg-[#F2EEE7]/95 backdrop-blur-sm sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-6 py-4">
          <Link to="/" className="inline-flex items-center gap-2 text-[#5C4033] hover:text-[#7A1E2C] transition-colors">
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-4xl font-serif font-bold text-[#5C4033] mb-4">Contact Us</h1>
        <p className="text-[#6B5B4F] text-lg mb-12">Have a question or want to learn more? Reach out to us.</p>

        <div className="space-y-6">
          <a 
            href="mailto:sharedequal@gmail.com"
            className="flex items-center gap-4 p-6 bg-white rounded-lg border border-[#D4CFC7] hover:border-[#7A1E2C] transition-colors group"
          >
            <div className="w-12 h-12 rounded-full bg-[#7A1E2C]/10 flex items-center justify-center">
              <Mail className="w-5 h-5 text-[#7A1E2C]" />
            </div>
            <div>
              <p className="text-sm text-[#6B5B4F]">Email</p>
              <p className="font-medium text-[#5C4033] group-hover:text-[#7A1E2C] transition-colors">sharedequal@gmail.com</p>
            </div>
          </a>

          <a 
            href="https://www.instagram.com/sharedequal/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-4 p-6 bg-white rounded-lg border border-[#D4CFC7] hover:border-[#7A1E2C] transition-colors group"
          >
            <div className="w-12 h-12 rounded-full bg-[#7A1E2C]/10 flex items-center justify-center">
              <Instagram className="w-5 h-5 text-[#7A1E2C]" />
            </div>
            <div>
              <p className="text-sm text-[#6B5B4F]">Instagram</p>
              <p className="font-medium text-[#5C4033] group-hover:text-[#7A1E2C] transition-colors">@sharedequal</p>
            </div>
          </a>
        </div>

        <div className="mt-12 pt-8 border-t border-[#D4CFC7]">
          <Link to="/" className="inline-flex items-center gap-2 text-[#7A1E2C] hover:underline font-medium">
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Contact;
